function e(r) {
  return r === null ? null : r.scrollHeight > r.clientHeight ? r : e(r.parentNode);
}
const a = [
  {
    currency: "Albania Lek",
    abbreviation: "ALL",
    htmlSymbol: "&#76;&#101;&#107;",
    symbol: "L"
  },
  {
    currency: "Afghanistan Afghani",
    abbreviation: "AFN",
    htmlSymbol: "&#1547;",
    symbol: "؋"
  },
  {
    currency: "Argentina Peso",
    abbreviation: "ARS",
    htmlSymbol: "&#36;",
    symbol: "$"
  },
  {
    currency: "Aruba Guilder",
    abbreviation: "AWG",
    htmlSymbol: "&#402;",
    symbol: "ƒ"
  },
  {
    currency: "Australia Dollar",
    abbreviation: "AUD",
    htmlSymbol: "&#36;",
    symbol: "$"
  },
  {
    currency: "Azerbaijan New Manat",
    abbreviation: "AZN",
    htmlSymbol: "&#1084;&#1072;&#1085;",
    symbol: "₼"
  },
  {
    currency: "Bahamas Dollar",
    abbreviation: "BSD",
    htmlSymbol: "&#36;",
    symbol: "$"
  },
  {
    currency: "Barbados Dollar",
    abbreviation: "BBD",
    htmlSymbol: "&#36;",
    symbol: "$"
  },
  {
    currency: "Belarus Ruble",
    abbreviation: "BYR",
    htmlSymbol: "&#112;&#46;",
    symbol: "Br"
  },
  {
    currency: "Belize Dollar",
    abbreviation: "BZD",
    htmlSymbol: "&#66;&#90;&#36;",
    symbol: "$"
  },
  {
    currency: "Bermuda Dollar",
    abbreviation: "BMD",
    htmlSymbol: "&#36;",
    symbol: "$"
  },
  {
    currency: "Bolivia Boliviano",
    abbreviation: "BOB",
    htmlSymbol: "&#36;&#98;",
    symbol: "Bs"
  },
  {
    currency: "Bosnia and Herzegovina Convertible Marka",
    abbreviation: "BAM",
    htmlSymbol: "&#75;&#77;",
    symbol: "KM"
  },
  {
    currency: "Botswana Pula",
    abbreviation: "BWP",
    htmlSymbol: "&#80;",
    symbol: "P"
  },
  {
    currency: "Bulgaria Lev",
    abbreviation: "BGN",
    htmlSymbol: "&#1083;&#1074;",
    symbol: "лв"
  },
  {
    currency: "Brazil Real",
    abbreviation: "BRL",
    htmlSymbol: "&#82;&#36;",
    symbol: "R$"
  },
  {
    currency: "Brunei Darussalam Dollar",
    abbreviation: "BND",
    htmlSymbol: "&#36;",
    symbol: "$"
  },
  {
    currency: "Cambodia Riel",
    abbreviation: "KHR",
    htmlSymbol: "&#6107;",
    symbol: "៛"
  },
  {
    currency: "Canada Dollar",
    abbreviation: "CAD",
    htmlSymbol: "&#36;",
    symbol: "$"
  },
  {
    currency: "Cayman Islands Dollar",
    abbreviation: "KYD",
    htmlSymbol: "&#36;",
    symbol: "$"
  },
  {
    currency: "Chile Peso",
    abbreviation: "CLP",
    htmlSymbol: "&#36;",
    symbol: "$"
  },
  {
    currency: "China Yuan Renminbi",
    abbreviation: "CNY",
    htmlSymbol: "&#165;",
    symbol: "¥"
  },
  {
    currency: "Colombia Peso",
    abbreviation: "COP",
    htmlSymbol: "&#36;",
    symbol: "$"
  },
  {
    currency: "Costa Rica Colon",
    abbreviation: "CRC",
    htmlSymbol: "&#8353;",
    symbol: "₡"
  },
  {
    currency: "Croatia Kuna",
    abbreviation: "HRK",
    htmlSymbol: "&#107;&#110;",
    symbol: "kn"
  },
  {
    currency: "Cuba Peso",
    abbreviation: "CUP",
    htmlSymbol: "&#8369;",
    symbol: "₱"
  },
  {
    currency: "Czech Republic Koruna",
    abbreviation: "CZK",
    htmlSymbol: "&#75;&#269;",
    symbol: "Kč"
  },
  {
    currency: "Denmark Krone",
    abbreviation: "DKK",
    htmlSymbol: "&#107;&#114;",
    symbol: "kr"
  },
  {
    currency: "Dominican Republic Peso",
    abbreviation: "DOP",
    htmlSymbol: "&#82;&#68;&#36;",
    symbol: "$"
  },
  {
    currency: "East Caribbean Dollar",
    abbreviation: "XCD",
    htmlSymbol: "&#36;",
    symbol: "$"
  },
  {
    currency: "Egypt Pound",
    abbreviation: "EGP",
    htmlSymbol: "&#163;",
    symbol: "£"
  },
  {
    currency: "El Salvador Colon",
    abbreviation: "SVC",
    htmlSymbol: "&#36;",
    symbol: "₡"
  },
  {
    currency: "Estonia Kroon",
    abbreviation: "EEK",
    htmlSymbol: "&#107;&#114;",
    symbol: "kr"
  },
  {
    currency: "Euro Member Countries",
    abbreviation: "EUR",
    htmlSymbol: "&#8364;",
    symbol: "€"
  },
  {
    currency: "Falkland Islands (Malvinas) Pound",
    abbreviation: "FKP",
    htmlSymbol: "&#163;",
    symbol: "£"
  },
  {
    currency: "Fiji Dollar",
    abbreviation: "FJD",
    htmlSymbol: "&#36;",
    symbol: "$"
  },
  {
    currency: "Ghana Cedis",
    abbreviation: "GHC",
    htmlSymbol: "&#162;",
    symbol: "₵"
  },
  {
    currency: "Gibraltar Pound",
    abbreviation: "GIP",
    htmlSymbol: "&#163;",
    symbol: "£"
  },
  {
    currency: "Guatemala Quetzal",
    abbreviation: "GTQ",
    htmlSymbol: "&#81;",
    symbol: "Q"
  },
  {
    currency: "Guernsey Pound",
    abbreviation: "GGP",
    htmlSymbol: "&#163;",
    symbol: "£"
  },
  {
    currency: "Guyana Dollar",
    abbreviation: "GYD",
    htmlSymbol: "&#36;",
    symbol: "$"
  },
  {
    currency: "Honduras Lempira",
    abbreviation: "HNL",
    htmlSymbol: "&#76;",
    symbol: "L"
  },
  {
    currency: "Hong Kong Dollar",
    abbreviation: "HKD",
    htmlSymbol: "&#36;",
    symbol: "$"
  },
  {
    currency: "Hungary Forint",
    abbreviation: "HUF",
    htmlSymbol: "&#70;&#116;",
    symbol: "Ft"
  },
  {
    currency: "Iceland Krona",
    abbreviation: "ISK",
    htmlSymbol: "&#107;&#114;",
    symbol: "kr"
  },
  {
    currency: "India Rupee",
    abbreviation: "INR",
    htmlSymbol: null,
    symbol: "₹"
  },
  {
    currency: "Indonesia Rupiah",
    abbreviation: "IDR",
    htmlSymbol: "&#82;&#112;",
    symbol: "Rp"
  },
  {
    currency: "Iran Rial",
    abbreviation: "IRR",
    htmlSymbol: "&#65020;",
    symbol: "﷼"
  },
  {
    currency: "Isle of Man Pound",
    abbreviation: "IMP",
    htmlSymbol: "&#163;",
    symbol: "£"
  },
  {
    currency: "Israel Shekel",
    abbreviation: "ILS",
    htmlSymbol: "&#8362;",
    symbol: "₪"
  },
  {
    currency: "Jamaica Dollar",
    abbreviation: "JMD",
    htmlSymbol: "&#74;&#36;",
    symbol: "$"
  },
  {
    currency: "Japan Yen",
    abbreviation: "JPY",
    htmlSymbol: "&#165;",
    symbol: "¥"
  },
  {
    currency: "Jersey Pound",
    abbreviation: "JEP",
    htmlSymbol: "&#163;",
    symbol: "£"
  },
  {
    currency: "Kazakhstan Tenge",
    abbreviation: "KZT",
    htmlSymbol: "&#1083;&#1074;",
    symbol: "₸"
  },
  {
    currency: "Korea (North) Won",
    abbreviation: "KPW",
    htmlSymbol: "&#8361;",
    symbol: "₩"
  },
  {
    currency: "Korea (South) Won",
    abbreviation: "KRW",
    htmlSymbol: "&#8361;",
    symbol: "₩"
  },
  {
    currency: "Kyrgyzstan Som",
    abbreviation: "KGS",
    htmlSymbol: "&#1083;&#1074;",
    symbol: "лв"
  },
  {
    currency: "Laos Kip",
    abbreviation: "LAK",
    htmlSymbol: "&#8365;",
    symbol: "₭"
  },
  {
    currency: "Latvia Lat",
    abbreviation: "LVL",
    htmlSymbol: "&#76;&#115;",
    symbol: "Ls"
  },
  {
    currency: "Lebanon Pound",
    abbreviation: "LBP",
    htmlSymbol: "&#163;",
    symbol: "£"
  },
  {
    currency: "Liberia Dollar",
    abbreviation: "LRD",
    htmlSymbol: "&#36;",
    symbol: "$"
  },
  {
    currency: "Lithuania Litas",
    abbreviation: "LTL",
    htmlSymbol: "&#76;&#116;",
    symbol: "Lt"
  },
  {
    currency: "Macedonia Denar",
    abbreviation: "MKD",
    htmlSymbol: "&#1076;&#1077;&#1085;",
    symbol: "ден"
  },
  {
    currency: "Malaysia Ringgit",
    abbreviation: "MYR",
    htmlSymbol: "&#82;&#77;",
    symbol: "RM"
  },
  {
    currency: "Mauritius Rupee",
    abbreviation: "MUR",
    htmlSymbol: "&#8360;",
    symbol: "₨"
  },
  {
    currency: "Mexico Peso",
    abbreviation: "MXN",
    htmlSymbol: "&#36;",
    symbol: "$"
  },
  {
    currency: "Mongolia Tughrik",
    abbreviation: "MNT",
    htmlSymbol: "&#8366;",
    symbol: "₮"
  },
  {
    currency: "Mozambique Metical",
    abbreviation: "MZN",
    htmlSymbol: "&#77;&#84;",
    symbol: "MT"
  },
  {
    currency: "Namibia Dollar",
    abbreviation: "NAD",
    htmlSymbol: "&#36;",
    symbol: "$"
  },
  {
    currency: "Nepal Rupee",
    abbreviation: "NPR",
    htmlSymbol: "&#8360;",
    symbol: "₨"
  },
  {
    currency: "Netherlands Antilles Guilder",
    abbreviation: "ANG",
    htmlSymbol: "&#402;",
    symbol: "ƒ"
  },
  {
    currency: "New Zealand Dollar",
    abbreviation: "NZD",
    htmlSymbol: "&#36;",
    symbol: "$"
  },
  {
    currency: "Nicaragua Cordoba",
    abbreviation: "NIO",
    htmlSymbol: "&#67;&#36;",
    symbol: "C$"
  },
  {
    currency: "Nigeria Naira",
    abbreviation: "NGN",
    htmlSymbol: "&#8358;",
    symbol: "₦"
  },
  {
    currency: "Korea (North) Won",
    abbreviation: "KPW",
    htmlSymbol: "&#8361;",
    symbol: "₩"
  },
  {
    currency: "Norway Krone",
    abbreviation: "NOK",
    htmlSymbol: "&#107;&#114;",
    symbol: "kr"
  },
  {
    currency: "Oman Rial",
    abbreviation: "OMR",
    htmlSymbol: "&#65020;",
    symbol: "﷼"
  },
  {
    currency: "Pakistan Rupee",
    abbreviation: "PKR",
    htmlSymbol: "&#8360;",
    symbol: "₨"
  },
  {
    currency: "Panama Balboa",
    abbreviation: "PAB",
    htmlSymbol: "&#66;&#47;&#46;",
    symbol: "B/."
  },
  {
    currency: "Paraguay Guarani",
    abbreviation: "PYG",
    htmlSymbol: "&#71;&#115;",
    symbol: "Gs"
  },
  {
    currency: "Peru Nuevo Sol",
    abbreviation: "PEN",
    htmlSymbol: "&#83;&#47;&#46;",
    symbol: "S/."
  },
  {
    currency: "Philippines Peso",
    abbreviation: "PHP",
    htmlSymbol: "&#8369;",
    symbol: "₱"
  },
  {
    currency: "Poland Zloty",
    abbreviation: "PLN",
    htmlSymbol: "&#122;&#322;",
    symbol: "zł"
  },
  {
    currency: "Qatar Riyal",
    abbreviation: "QAR",
    htmlSymbol: "&#65020;",
    symbol: "﷼"
  },
  {
    currency: "Romania New Leu",
    abbreviation: "RON",
    htmlSymbol: "&#108;&#101;&#105;",
    symbol: "lei"
  },
  {
    currency: "Russia Ruble",
    abbreviation: "RUB",
    htmlSymbol: "&#1088;&#1091;&#1073;",
    symbol: "₽"
  },
  {
    currency: "Saint Helena Pound",
    abbreviation: "SHP",
    htmlSymbol: "&#163;",
    symbol: "£"
  },
  {
    currency: "Saudi Arabia Riyal",
    abbreviation: "SAR",
    htmlSymbol: "&#65020;",
    symbol: "﷼"
  },
  {
    currency: "Serbia Dinar",
    abbreviation: "RSD",
    htmlSymbol: "&#1044;&#1080;&#1085;&#46;",
    symbol: "дин"
  },
  {
    currency: "Seychelles Rupee",
    abbreviation: "SCR",
    htmlSymbol: "&#8360;",
    symbol: "₨"
  },
  {
    currency: "Singapore Dollar",
    abbreviation: "SGD",
    htmlSymbol: "&#36;",
    symbol: "$"
  },
  {
    currency: "Solomon Islands Dollar",
    abbreviation: "SBD",
    htmlSymbol: "&#36;",
    symbol: "$"
  },
  {
    currency: "Somalia Shilling",
    abbreviation: "SOS",
    htmlSymbol: "&#83;",
    symbol: "S"
  },
  {
    currency: "South Africa Rand",
    abbreviation: "ZAR",
    htmlSymbol: "&#82;",
    symbol: "R"
  },
  {
    currency: "Korea (South) Won",
    abbreviation: "KRW",
    htmlSymbol: "&#8361;",
    symbol: "₩"
  },
  {
    currency: "Sri Lanka Rupee",
    abbreviation: "LKR",
    htmlSymbol: "&#8360;",
    symbol: "₨"
  },
  {
    currency: "Sweden Krona",
    abbreviation: "SEK",
    htmlSymbol: "&#107;&#114;",
    symbol: "kr"
  },
  {
    currency: "Switzerland Franc",
    abbreviation: "CHF",
    htmlSymbol: "&#67;&#72;&#70;",
    symbol: "CHF"
  },
  {
    currency: "Suriname Dollar",
    abbreviation: "SRD",
    htmlSymbol: "&#36;",
    symbol: "$"
  },
  {
    currency: "Syria Pound",
    abbreviation: "SYP",
    htmlSymbol: "&#163;",
    symbol: "£"
  },
  {
    currency: "Taiwan New Dollar",
    abbreviation: "TWD",
    htmlSymbol: "&#78;&#84;&#36;",
    symbol: "NT$"
  },
  {
    currency: "Thailand Baht",
    abbreviation: "THB",
    htmlSymbol: "&#3647;",
    symbol: "฿"
  },
  {
    currency: "Trinidad and Tobago Dollar",
    abbreviation: "TTD",
    htmlSymbol: "&#84;&#84;&#36;",
    symbol: "$"
  },
  {
    currency: "Turkey Lira",
    abbreviation: "TRY",
    htmlSymbol: null,
    symbol: "₺"
  },
  {
    currency: "Turkey Lira",
    abbreviation: "TRL",
    htmlSymbol: "&#8356;",
    symbol: "₺"
  },
  {
    currency: "Tuvalu Dollar",
    abbreviation: "TVD",
    htmlSymbol: "&#36;",
    symbol: "$"
  },
  {
    currency: "Ukraine Hryvna",
    abbreviation: "UAH",
    htmlSymbol: "&#8372;",
    symbol: "₴"
  },
  {
    currency: "United Kingdom Pound",
    abbreviation: "GBP",
    htmlSymbol: "&#163;",
    symbol: "£"
  },
  {
    currency: "United States Dollar",
    abbreviation: "USD",
    htmlSymbol: "&#36;",
    symbol: "$"
  },
  {
    currency: "Uruguay Peso",
    abbreviation: "UYU",
    htmlSymbol: "&#36;&#85;",
    symbol: "$"
  },
  {
    currency: "Uzbekistan Som",
    abbreviation: "UZS",
    htmlSymbol: "&#1083;&#1074;",
    symbol: "сўм"
  },
  {
    currency: "Venezuela Bolivar",
    abbreviation: "VEF",
    htmlSymbol: "&#66;&#115;",
    symbol: "Bs"
  },
  {
    currency: "Viet Nam Dong",
    abbreviation: "VND",
    htmlSymbol: "&#8363;",
    symbol: "₫"
  },
  {
    currency: "Yemen Rial",
    abbreviation: "YER",
    htmlSymbol: "&#65020;",
    symbol: "﷼"
  },
  {
    currency: "Zimbabwe Dollar",
    abbreviation: "ZWD",
    htmlSymbol: "&#90;&#36;",
    symbol: "Z$"
  }
];
function n() {
  return [...new Set(a.map((r) => r.symbol))];
}
function i(r, o = "symbol") {
  const l = a.findIndex((b) => b.abbreviation.toLowerCase().trim() === r.toLowerCase().trim());
  return l === -1 ? r : o === "symbol" ? a[l].symbol : a[l].htmlSymbol;
}
function m(r) {
  const o = a.findIndex((l) => l.symbol === r);
  return o === -1 ? r : a[o].abbreviation;
}
function y(r) {
  const o = r * 1024, l = ["Bytes", "KB", "MB", "GB", "TB"];
  if (o === 0)
    return "n/a";
  const b = parseFloat(`${Math.floor(Math.log(o) / Math.log(1024))}`);
  return `${o / parseInt((1024 ** b).toFixed(1), 10)}${l[b]}`;
}
function t(r) {
  return r.reduce((l, b) => (l.push(b.split("/")[1] || b), l), []).join(", ");
}
function c(r) {
  return new Promise((o, l) => {
    const b = new FileReader();
    b.onerror = l, b.onload = () => o(b.result), b.readAsDataURL(r);
  });
}
function u(r) {
  return r % 2 === 0;
}
function s(r, o) {
  return Math.floor(Math.random() * (o - r)) + r;
}
function S(r) {
  return r.charAt(0).toUpperCase() + r.slice(1);
}
function h(r) {
  return `${r / parseFloat(window.getComputedStyle(document.documentElement).fontSize.replace("px", ""))}rem`;
}
function v(r) {
  return r.normalize("NFD").replace(new RegExp("\\p{Diacritic}", "gu"), "");
}
function D(r) {
  const o = r.substring(r.indexOf(":") + 1, r.indexOf(";")), l = r.split(",")[1];
  return {
    mimeType: o,
    content: l,
    raw: r
  };
}
export {
  S as capitalize,
  h as convertPixelsToRem,
  y as filesizeToHumanReadable,
  n as getAllSymbolCurrencies,
  m as getCurrencyAbbreviationBySymbol,
  i as getCurrencySymbol,
  t as getFileExtension,
  e as getScrollableParent,
  u as isEven,
  v as normalizeString,
  s as randomIntegerBetweenTwo,
  c as readFileAsync,
  D as splitBase64
};
//# sourceMappingURL=utils.es.js.map
